import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';
import { a as getPadding } from './styled-utils-3f8463ca.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  text-align: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTCell = styled.td(_templateObject(), function (_ref) {
  var padding = _ref.padding,
      theme = _ref.theme;
  return padding && getPadding(padding, theme);
}, function (_ref2) {
  var textAlign = _ref2.textAlign;
  return textAlign && textAlign;
});

var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      padding = _ref.padding,
      align = _ref.align,
      className = _ref.className;
  return React.createElement(StyledTCell, {
    textAlign: align,
    padding: padding,
    className: className
  }, children);
};

TableCell.defaultProps = {
  align: 'left',
  className: null,
  padding: null
};
TableCell.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableCell",
  "props": {
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Text alignment for the cell"
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "padding": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The padding value to be used on the Row. Based on the bootstrap padding classes"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The content of the TableCell"
    }
  }
};
export default TableCell;
export { TableCell };